export const SET_CART_STATE = 'SET_CART_STATE';
export const SET_CART_DATA = 'SET_CART_DATA';
export const RESET_CART_DATA = 'RESET_CART_DATA';
export const SET_CART_ITEM_DATA = 'SET_CART_ITEM_DATA';
export const DELETE_CART_ITEM = 'DELETE_CART_ITEM';

// shipping
export const SET_SHIPPING_DATA = 'SET_SHIPPING_DATA';
export const SET_PICKUP_VALUE = 'SET_PICKUP_VALUE';
export const SET_SHIPPING_VALUE = 'SET_SHIPPING_VALUE';
export const SET_SHIPPING_COST = 'SET_SHIPPING_COST';
export const SET_SHIPPING_ERROR = 'SET_SHIPPING_ERROR';
export const SET_SHIPPING_STATUS = 'SET_SHIPPING_STATUS';

// payment
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const SET_INVOICE_DATA = 'SET_INVOICE_DATA';
export const SET_PAYMENT_DATA = 'SET_PAYMENT_DATA';

// user
export const SET_USER_DATA = 'SET_USER_DATA';

// result
export const SET_RESULT_DATA = 'SET_RESULT_DATA';